import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { AddControlService } from '../add-controls/add-control.service';

@FormComponentLookup('hyperlink-reset-close')
@Component({
    selector: 'app-hyperlink-reset-close',
    templateUrl: './hyperlink-reset-close.component.html',
    styleUrls: ['./hyperlink-reset-close.component.scss'],
    standalone: false
})
export class HyperlinkResetCloseComponent extends FormEntryComponentClass implements OnInit, AfterViewInit { 

  resetActionName: String;

  constructor( private addControlService: AddControlService) {
    super();
  }

  ngOnInit() {
    console.log('Service CLoseaction name', this.addControlService.activeCloseAction);
    this.resetActionName = this.addControlService.activeCloseAction;
   }

  ngAfterViewInit(): void {
   
  }

  removeControls() {
      this.addControlService.removeControl(this.entry, this.currentPage, this.resetActionName, this.form);
 
    }
}
